module.exports = __webpack_public_path__ + "img/ALLMG-PIC.fb5f2a9e.png";